import React, { Component, RefObject } from "react";
import styled from "styled-components";
import { Icon } from "js/Components/Icon";

const TaskLabel = styled.span<{ done: boolean }>`
    color: black;
    font-size: 16px;
    font-weight: 500;
    text-decoration: ${props => props.done ? "line-through" : "none"};
`;

const TaskItemContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-family: "Source Sans Pro";
    font-size: 16px;
    font-weight: 400;
    line-height: 125%;
    letter-spacing: -0.32px;

    :hover {
        background-color: #EEE;
        cursor: pointer;
    }
`;

export interface Task {
    title: string;
    key: string;
    done: boolean;
}

export interface TaskItemProps {
    task: Task;
    onClick: () => void;
    containerRef?: RefObject<HTMLDivElement>;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
}

export class TaskItem extends Component<TaskItemProps> {
    render() {
        const { task, onClick, containerRef, onMouseEnter, onMouseLeave } = this.props;

        return (
            <TaskItemContainer
                ref={containerRef}
                onClick={onClick}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <Icon color="black" large >
                    {task.done ? "check_circle_outline" : "circle"}
                </Icon>
                <TaskLabel done={task.done}>
                    {task.title}
                </TaskLabel>
            </TaskItemContainer>
        );
    }
}

export default TaskItem;

